import React from "react";
import BannerListingPage from "./BannerListing/BannerListingPage";
import BannersDetailPage from "./BannerDetail/BannersDetailPage";
import HeadingText from "components/common/HeadingText/HeadingText";
import { ICustomerPageState } from "interfaces/Index";
import { IBannerPageProps } from "interfaces/banner.interface";

export default class BannerPage extends React.Component<
  IBannerPageProps,
  ICustomerPageState
> {
  constructor(props: IBannerPageProps) {
    super(props);
    this.state = {
      showAddUpdatePage: false,
      selectedBanner: null,
      selectedCity: null,
      isBannerUpdated: false,
      selectedCustomerChannel: null
    };
  }

  renderBannerDetailsPage = () => {
    const { selectedBanner, selectedCity, selectedCustomerChannel } = this.state;
    return (
      <BannersDetailPage
        {...this.props}
        selectedCustomerChannel={selectedCustomerChannel}
        selectedBanner={selectedBanner}
        selectedCity={selectedCity}
        backButtonHandler={this.navigateBackToListingPage}
      />
    );
  };

  renderBannerListing = () => {
    const {
      fetchCities,
      getBanners,
      updateBannerSequence,
      isBannerSequenceUpdated,
      cityList,
      isLoading,
      error,
      isError,
      banner,
      isBannerFetched,
      customerConfig,
      fetchCustomerChannelAction,
    } = this.props;
    const { isBannerUpdated, selectedCity, selectedCustomerChannel } = this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Banners" isMainHeading={true} />
        </section>
        <BannerListingPage
          cityList={cityList}
          fetchCities={fetchCities}
          isLoading={isLoading}
          retainedSelectedCity={selectedCity}
          isError={isError}
          error={error}
          isBannerUpdated={isBannerUpdated}
          editPageHandler={this.toggleEditBannerPage}
          banner={banner}
          getBanners={getBanners}
          isBannerFetched={isBannerFetched}
          updateBannerSequence={updateBannerSequence}
          isBannerSequenceUpdated={isBannerSequenceUpdated}
          fetchCustomerChannelAction={fetchCustomerChannelAction}
          customerConfig={customerConfig}
          selectedCustomerChannel={selectedCustomerChannel}
        />
      </>
    );
  };

  toggleEditBannerPage = (
    selectedBanner: any = null,
    selectedCity: any = null,
    selectedCustomerChannel: any = null
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      selectedBanner: selectedBanner,
      selectedCity: selectedCity,
      isBannerUpdated: false,
      selectedCustomerChannel
    });
  };

  navigateBackToListingPage = (isBannerUpdated: boolean) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isBannerUpdated: isBannerUpdated,
      selectedBanner: null,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderBannerDetailsPage()
          : this.renderBannerListing()}
      </div>
    );
  }
}
